import React, { useState, useEffect } from 'react';
import { Award, Users, Target, Leaf } from 'lucide-react';
import './About.css';
import useSEO from '../hooks/useSEO';

const About = () => {
  const [aboutContent, setAboutContent] = useState({
    intro: null,
    mission: null,
    vision: null,
    values: [],
    timeline: []
  });
  const [loading, setLoading] = useState(true);

  useSEO({
    title: 'Hakkımızda - Efruz İnşaat | Kalite ve Güvenilirlik',
    description: 'Efruz İnşaat olarak 14+ yıldır kalite, güven ve yenilikçilik ilkeleriyle Türkiye\'nin önde gelen inşaat projelerine imza atıyoruz. Uzman ekibimiz ve değerlerimiz hakkında bilgi edinin.',
    keywords: 'efruz inşaat hakkında, inşaat firması tarihçe, inşaat ekibi, kalite standartları, inşaat değerleri, müşteri memnuniyeti'
  });

  useEffect(() => {
    const fetchAboutContent = async () => {
      try {
        const API_BASE = process.env.REACT_APP_API_URL || '/public/api';
        const response = await fetch(`${API_BASE}/about_content.php`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const text = await response.text();
        const result = JSON.parse(text);
        if (result.success) {
          setAboutContent(result.data || {});
        } else {
          console.error('Failed to fetch about content:', result.error);
        }
      } catch (error) {
        console.error('Error fetching about content:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAboutContent();
  }, []);

  const iconMap = {
    'Kalite': Award,
    'Güven': Users,
    'Yenilikçilik': Target,
    'Sürdürülebilirlik': Leaf
  };

  return (
    <div className="about-page">
      {/* Page Title Section */}
      <section className="page-title-section">
        <div className="container">
          <h1 className="page-title">Hakkımızda</h1>
          <p className="page-description">
            {loading ? 'Yükleniyor...' : (aboutContent.intro?.content || 'Efruz İnşaat olarak 14+ yıldır Türkiye\'nin önde gelen inşaat projelerine imza atıyoruz. Kalite, güven ve yenilikçilik ilkelerimizle müşterilerimizin hayallerini gerçeğe dönüştürüyoruz.')}
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mission-vision section-padding">
        <div className="container">
          <div className="mission-vision-modern-grid">
            <div className="mission-vision-modern-card">
              <div className="mission-vision-number">01</div>
              <div className="mission-vision-icon-wrapper">
                <div className="mission-vision-icon-bg"></div>
                <Target size={36} className="mission-vision-icon" />
              </div>
              <div className="mission-vision-content">
                <h2 className="heading-2">{aboutContent.mission?.title || 'Misyonumuz'}</h2>
                <p className="body-regular">{aboutContent.mission?.content || 'Yükleniyor...'}</p>
              </div>
              <div className="mission-vision-hover-line"></div>
            </div>
            <div className="mission-vision-modern-card">
              <div className="mission-vision-number">02</div>
              <div className="mission-vision-icon-wrapper">
                <div className="mission-vision-icon-bg"></div>
                <Award size={36} className="mission-vision-icon" />
              </div>
              <div className="mission-vision-content">
                <h2 className="heading-2">{aboutContent.vision?.title || 'Vizyonumuz'}</h2>
                <p className="body-regular">{aboutContent.vision?.content || 'Yükleniyor...'}</p>
              </div>
              <div className="mission-vision-hover-line"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="values-section section-padding">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">Değerlerimiz</h2>
            <p className="body-large">Bizi biz yapan ilkeler</p>
          </div>
          <div className="values-modern-grid">
            {loading ? (
              <p>Yükleniyor...</p>
            ) : (
              (aboutContent.values?.content || []).map((value, index) => {
                const IconComponent = iconMap[value.title] || Award;
                return (
                  <div key={index} className="value-modern-card">
                    <div className="value-modern-number">0{index + 1}</div>
                    <div className="value-modern-icon-wrapper">
                      <div className="value-modern-icon-bg"></div>
                      <IconComponent size={32} className="value-modern-icon" />
                    </div>
                    <div className="value-modern-content">
                      <h3 className="heading-3">{value.title}</h3>
                      <p className="body-regular">{value.description}</p>
                    </div>
                    <div className="value-modern-hover-line"></div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="timeline-section section-padding">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">Tarihçemiz</h2>
            <p className="body-large">Mükemmelliğe giden yolculuk</p>
          </div>
          <div className="timeline-modern">
            <div className="timeline-modern-line"></div>
            <div className="timeline-modern-items">
              {loading ? (
                <p>Yükleniyor...</p>
              ) : (
                (aboutContent.timeline?.content || []).map((item, index) => (
                  <div key={index} className="timeline-modern-item">
                    <div className="timeline-modern-circle">
                      <span className="timeline-modern-year">{item.year}</span>
                    </div>
                    <div className="timeline-modern-content">
                      <h4 className="heading-3">{item.title || item.heading || ''}</h4>
                      <p className="body-regular">{item.description || ''}</p>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default About;
